import React from 'react';
import { connect } from 'react-redux';
import { Layout, Dropdown, Menu } from 'antd';
import { supportLangs, supportLangKeys } from '../../locales';
import LanguageAction from '../../reducers/language/action';
import CONSTANT from '../../constant';

const Language = props => {
    const handleMenuClick = async ({key, item}) => {
        if (key && item) {
            props.change(key);
        }
    };

    const mainMenu = () => {
        const langKey = props.intlr.langKey;

        return (
            <Menu className="header-dropdown-menu" subMenuOpenDelay={0.1} onClick={handleMenuClick}>
                {supportLangKeys.map(lang => <Menu.Item style={lang === langKey && {backgroundColor: '#46b5ff'}} key={`${lang}`}>{supportLangs[lang].name}</Menu.Item>)}
            </Menu>
        );
    };

    const isForbidden = () => {
        const { project } = props;
        const { showLoadingPage, saveStatus } = project;
        return showLoadingPage || saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING ? true : false;
    };

    const renderLanguage = () => {
        return (
            <Layout.Header className="header">
                <Dropdown
                    disabled={isForbidden()}
                    trigger={['click']}
                    overlay={mainMenu()}
                >
                    <span className='mblock-icon icon-yuyanxuanze'></span>
                </Dropdown>
            </Layout.Header>
        );
    };

    return (
        <section className="header-cell lanuage-cell" title={props.intlr.messages['MENU.LANGUAGE']}>
            {renderLanguage()}
        </section>
    );
};

export default connect(state => ({
    intlr: state.intlr,
    project: state.project
}), dispatch => ({
    change: lang => dispatch(LanguageAction.change(lang)),
}))(Language);